const HelpCenter = () => import('Views/helpCenter/help-center');
const Instructions = () => import('Views/helpCenter/instructions');
const Introduction = () => import('Views/helpCenter/introduction');
const Document = () => import('Views/helpCenter/document');
const DocumentDetail = () => import('Views/helpCenter/document-detail');

export default[
  { path: '/help-center', component: HelpCenter },
  { path: '/instructions', component: Instructions },
  { path: '/introduction', component: Introduction },
  { path: '/document-detail/:id', component: DocumentDetail },
  { path: '/document', component: Document },
];



// WEBPACK FOOTER //
// ./src/router/helpCenter.js